import { render, staticRenderFns } from "./CardContent.vue?vue&type=template&id=594a4050&scoped=true"
import script from "./CardContent.vue?vue&type=script&lang=js"
export * from "./CardContent.vue?vue&type=script&lang=js"
import style0 from "./CardContent.vue?vue&type=style&index=0&id=594a4050&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "594a4050",
  null
  
)

export default component.exports